"use client";

import React from "react";
import { House, Building2, ArrowRightLeft } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheBridgeToYourProject() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="the-bridge-to-your-project" className="w-full py-24 lg:py-32 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-muted/30 pointer-events-none" />

      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="relative flex flex-col md:flex-row items-center justify-between gap-12 lg:gap-8">
          
          {}
          <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-[2px] bg-gradient-to-r from-transparent via-border to-transparent -translate-y-1/2 z-0">
            {}
            <div className="absolute top-1/2 left-1/4 w-2 h-2 bg-primary rounded-full -translate-y-1/2 -translate-x-1/2 animate-pulse" />
            <div className="absolute top-1/2 left-3/4 w-2 h-2 bg-primary rounded-full -translate-y-1/2 -translate-x-1/2 animate-pulse" />
          </div>

          {}
          <div className="relative z-10 flex flex-col items-center text-center w-full md:w-1/4">
            <div className="w-20 h-20 rounded-full bg-background border-2 border-primary/20 shadow-lg shadow-primary/5 flex items-center justify-center mb-6 relative group transition-transform duration-300 hover:scale-105">
              <div className="absolute inset-0 rounded-full bg-primary/5 scale-0 group-hover:scale-100 transition-transform duration-300" />
              <House className="w-8 h-8 text-primary relative z-10" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              You & Your Project
            </h3>
            <p className="text-sm text-muted-foreground">
              Homeowners & Contractors
            </p>
          </div>

          {}
          <div className="relative z-10 flex flex-col items-center text-center w-full md:w-2/4 bg-background/80 backdrop-blur-sm px-6 py-10 md:px-10 md:py-12 rounded-3xl border border-border/60 shadow-xl shadow-foreground/5">
            <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-2xl mb-6">
              <ArrowRightLeft className="w-6 h-6 text-primary" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
              We are the Bridge,<br className="hidden lg:block" /> Not the Bank.
            </h2>
            <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-2xl mx-auto font-medium">
              Lana connect LLC seamlessly connects you with top-tier financing platforms. We don't lend the money; we are the experts providing the <strong className="text-foreground font-semibold">one connection</strong> you need to fund your next project.
            </p>
          </div>

          {}
          <div className="relative z-10 flex flex-col items-center text-center w-full md:w-1/4">
            <div className="w-20 h-20 rounded-full bg-background border-2 border-primary/20 shadow-lg shadow-primary/5 flex items-center justify-center mb-6 relative group transition-transform duration-300 hover:scale-105">
              <div className="absolute inset-0 rounded-full bg-primary/5 scale-0 group-hover:scale-100 transition-transform duration-300" />
              <Building2 className="w-8 h-8 text-primary relative z-10" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Vetted Lenders
            </h3>
            <p className="text-sm text-muted-foreground">
              Financing Platforms
            </p>
          </div>

        </div>
      </div>
    </section>;
}